<template>
    <form class="form-horizontal">
        <!-- <pre>{{fields}}</pre> -->
        <b-form-group
            :label-for="`date`"
            :label-cols="formColumn"
            label="Check Out:"
        >
            <!-- Content here -->
            <vet-datetime
                id="checkout_date"
                v-model="data.checkout_date"
                :container="data.modalWindow"
                :placeholder="{
                    date: 'Checkout date (required)',
                    time: 'Checkout time (required)'
                }"
                v-validate="'required'"
                rules="required"
                format="moment"
                name="checkout_date"
            ></vet-datetime>
        </b-form-group>
        <b-form-group :label-for="`due`" :label-cols="formColumn" label="Due:">
            <v-select
                id="due"
                ref="vselect"
                :options="_.difference(data.invoicesList, data.invoices)"
                v-model="data.invoices"
                placeholder="Select Invoice (optional)"
                multiple
            />
        </b-form-group>
        <b-form-group
            :label-for="`due`"
            :label-cols="formColumn"
            label="Credits:"
        >
            <v-select
                id="due"
                ref="vselect"
                :options="_.difference(data.creditsList, data.credits)"
                v-model="data.credits"
                :disabled="!has_invoice"
                placeholder="Select Credit (optional)"
                multiple
            />
        </b-form-group>
        <b-form-group
            :label-for="`collected`"
            :label-cols="formColumn"
            label="Collected:"
        >
            <b-form-input
                id="collected"
                v-model="data.payment_amount"
                :disabled="payable || !has_invoice"
                :class="{ 'border-danger': errors.has('collected') }"
                v-validate="{ required: true, max_value: 999999 }"
                placeholder="Collected (required)"
                type="number"
                step="0.01"
                name="collected"
            ></b-form-input>
        </b-form-group>
        <b-form-group
            :label-for="`payment_type`"
            :label-cols="formColumn"
            label="Type:"
        >
            <b-form-select
                id="payment_type"
                ref="payment_type"
                v-model="data.payment_type"
                :disabled="payable || !has_invoice || data.payment_amount <= 0"
                :class="{ 'border-danger': errors.has('payment_type') }"
                v-validate="data.payment_amount > 0 ? 'excluded:-1' : ''"
                class="form-control"
                name="payment_type"
            >
                <option value="-1"
                    >Please select a payment type ({{
                        data.payment_amount > 0 ? "required" : "optional"
                    }})</option
                >
                <template v-for="payment_type in data.paymentTypes">
                    <option
                        v-if="
                            payment_type.category_id === 2 &&
                            !isChangeFund &&
                            !isPayingMore
                        "
                        v-bind:value="payment_type.id"
                        :key="payment_type.id"
                    >
                        {{
                            getFundName(payment_type.name, payment_type.balance)
                        }}
                    </option>
                    <option
                        v-if="payment_type.category_id !== 2"
                        v-bind:value="payment_type.id"
                        :key="payment_type.id"
                    >
                        {{ payment_type.name }}
                    </option>
                </template>
            </b-form-select>
        </b-form-group>
        <b-form-group
            :label-for="`payment_method_name`"
            v-if="is_cc_card_in"
            :label-cols="formColumn"
            label="Payment Method:"
        >
            <vet-select
                id="payment_method_name"
                :key="data.payment_type_object.id"
                v-model="data.payment_method_name"
                :disabled="payable || !has_invoice"
                :payer="appData.client"
                :is-extension="'3'"
                :cc-processor="data.credit_card_processor"
                :class="{ 'border-danger': errors.has('payment_method_name') }"
                @options-loaded="_selectPrimaryMethod"
                v-validate="'required'"
                module="payment-method"
                placeholder="Payment Method (required)"
                name="payment_method_name"
            />
        </b-form-group>
        <b-form-group
            :label-for="`terminal`"
            v-if="is_cc_terminal"
            :label-cols="formColumn"
            label="Terminal:"
        >
            <b-form-select
                id="terminal"
                v-model="data.terminal"
                :class="{ 'border-danger': errors.has('terminal') }"
                :disabled="payable || !has_invoice || is_no_terminal"
                v-validate="'excluded:0'"
                name="terminal"
                class="form-control"
            >
                <option
                    v-for="(value, key) in data.terminals"
                    :key="key"
                    v-bind:value="key"
                    >{{ value }}</option
                >
            </b-form-select>
        </b-form-group>
        <!-- stripe terminal simulator start -->
        <b-form-group
            v-if="is_stripe_terminal && env.VUE_APP_ENV !== 'PROD'"
            :label-for="`simulator`"
            :label-cols="formColumn"
            label="Simulator:"
        >
            <b-form-select
                id="simulator"
                v-model="data.isSimulator"
                class="form-control"
                :options="[
                    {
                        text: 'Real device',
                        value: 0
                    },
                    {
                        text: 'Simulator',
                        value: 1
                    }
                ]"
                name="simulator"
            >
            </b-form-select>
        </b-form-group>
        <b-form-group
            v-if="data.isSimulator"
            :label-for="`testCardNumber`"
            :label-cols="formColumn"
            label="Test Card:"
        >
            <input
                id="testCardNumber"
                v-model="data.testCardNumber"
                type="text"
                class="form-control"
                name="testCardNumber"
                placeholder="4242424242424242"
            />
        </b-form-group>
        <!-- stripe terminal simulator end -->
        <b-form-group
            :label-for="`change`"
            :label-cols="formColumn"
            label="Change:"
        >
            <b-form-select
                id="change"
                v-model="data.change"
                :disabled="payable || !has_invoice || change_amount <= 0"
                name="change"
                class="form-control"
            >
                <option v-if="payable || change_amount <= 0" value="0"
                    >No change</option
                >
                <option
                    v-if="
                        _.findIndex(data.paymentTypes, { category_id: 1 }) >
                            -1 && !payable
                    "
                    value="1"
                    >{{ data.currency_symbol }}{{ change_amount }} (cash
                    back)</option
                >
                <option v-if="!payable" value="2"
                    >{{ data.currency_symbol
                    }}{{ change_amount }} (credit)</option
                >
                <template v-if="!isPaymentFund">
                    <option
                        v-for="(fund, i) in fundList"
                        :value="fund"
                        :key="fund.name + i"
                    >
                        {{ getNameForChange(fund.name, change_amount) }}
                    </option>
                </template>
            </b-form-select>
        </b-form-group>
        <b-form-group
            :label-for="`documents`"
            :label-cols="formColumn"
            label="Documents:"
        >
            <v-select
                id="documents"
                ref="documents"
                :options="documentOptions"
                v-model="data.documents"
                placeholder="Select Documents (optional)"
                multiple
                name="documents"
            />
        </b-form-group>
        <b-form-group
            :label-for="`rabies_tag`"
            :label-cols="formColumn"
            v-if="has_rabies_doc"
            label="Rabies Tag:"
        >
            <b-form-input
                id="rabies_tag"
                v-model="data.rabies.tag"
                v-validate="'required'"
                :class="{ 'border-danger': errors.has('rabies_tag') }"
                :key="has_rabies_doc ? 'rabies_doc' : 'no_rabies'"
                placeholder="Rabies Tag (required)"
                name="rabies_tag"
            ></b-form-input>
        </b-form-group>
        <b-form-group
            :label-for="`export_type`"
            :label-cols="formColumn"
            label="Export:"
        >
            <b-form-select
                id="export_type"
                v-model="data.export_type"
                :disabled="data.documents.length === 0"
                class="form-control"
            >
                <option :value="NO_EXPORT">None</option>
                <option v-if="data.client_email" :value="EXPORT_EMAIL"
                    >Email</option
                >
                <option :value="EXPORT_PRINT">Print</option>
            </b-form-select>
        </b-form-group>

        <b-form-group
            :label-for="`export_message`"
            :label-cols="formColumn"
            v-if="data.export_type == EXPORT_EMAIL"
            label="Message:"
        >
            <ContentEditable
                id="export_message"
                v-model="data.export_message"
                :template="template_object"
                :noHTML="false"
                tag="div"
                class="form-control"
            ></ContentEditable>
        </b-form-group>

        <b-form-group
            v-if="
                hasInvoices &&
                (data.export_type == EXPORT_EMAIL ||
                    data.export_type == EXPORT_PRINT)
            "
            label-for="include_declined"
            :label-cols="formColumn"
            label="Declined Items:"
        >
            <b-form-checkbox
                id="include_declined"
                v-model="data.includeDeclined"
                name="include_declined"
                plain
                class="col-form-label"
            >
                <span class="fw-normal">{{
                    TEXT_INCLUDE_DECLINED_ITEMS_INVOICE
                }}</span>
            </b-form-checkbox>
        </b-form-group>

        <b-form-group
            :label-for="`reminder`"
            :label-cols="formColumn"
            label="Reminders:"
        >
            <a
                id="reminder"
                v-b-popover.click.blur.top.focus.html.stop="
                    data.reminder_note || 'No reminder'
                "
                class="plain-text"
                href="javascript:void(0)"
                title="Reminder"
                >{{ data.reminder_message }}</a
            >
        </b-form-group>
    </form>
</template>
<script>
import Email from "@/services/email";
import CEMAIL from "@/constants/email";
import vSelect from "vue-select";
import vetSelect from "@/module/commons/vet-select.vue";
import vetDatetime from "@/module/commons/date-time-picker.vue";
import ContentEditable from "@/module/commons/content-editable-template";
import PaymentDialogHelper from "@/module/payment/helper.js";
import FundMixin from "@/mixins/fund.js";
import { debounce, isEmpty, find, findIndex, differenceBy, some } from "lodash";
import PaymentInvoiceSocketMixin from "@/mixins/payment-invoice-socket";
import { TEXT_INCLUDE_DECLINED_ITEMS_INVOICE } from "@/constants/billings.js";

const NO_EXPORT = 0;
const EXPORT_EMAIL = 1;
const EXPORT_PRINT = 3;
export default {
    name: "CheckOutForm",
    components: {
        vSelect,
        vetSelect,
        vetDatetime,
        ContentEditable
    },
    mixins: [PaymentDialogHelper, FundMixin, PaymentInvoiceSocketMixin],
    props: ["data", "appData", "currentPage"],
    data() {
        return {
            datePickerOptions: {
                widgetParent: "#statusModal",
                format: "DD/MM/YYYY"
            },
            timePickerOptions: {
                widgetParent: "#statusModal",
                format: "hh:mm A"
            },
            waitForPaymentMethod: false,
            NO_EXPORT,
            EXPORT_EMAIL,
            EXPORT_PRINT,
            TEXT_INCLUDE_DECLINED_ITEMS_INVOICE
        };
    },
    computed: {
        title() {
            return this.data && this.data.start
                ? this.data.start.format("hh:mm a") +
                      " - " +
                      this.data.end.format("hh:mm a")
                : "";
        },
        formColumn() {
            return this.col ? this.col : 3;
        },
        col() {
            return this.is_cc_card_in ? 4 : 3;
        },
        has_rabies_doc() {
            return _.find(this.data.documents, { id: "1" });
        },
        template_object() {
            let invoiceString = this._arrayToSentence(
                _.map(this.data.invoices, invoice =>
                    invoice.label.substring(0, invoice.label.indexOf(":"))
                )
            );

            return {
                INVOICE_NUMBER: invoiceString ? invoiceString : "[ - ]",
                PAYMENT_AMOUNT: this.data.payment_amount
                    ? this.data.payment_amount
                    : "0.00",
                PAYMENT_TYPE: _.get(this.data, "payment_type_object.name")
                    ? _.get(this.data, "payment_type_object.name")
                    : "[ - ]"
            };
        },
        isPayingMore() {
            return this.data.payment_amount > 0 && this.change_amount > 0;
        },
        documentOptions() {
            return differenceBy(
                this.data.documentsList,
                this.data.documents,
                "id"
            );
        },
        selectedInvoices() {
            return this.data.invoices;
        },
        hasInvoices() {
            return some(this.selectedInvoices, { is_invoice: true });
        }
    },
    watch: {
        "data.invoices": {
            async handler(value) {
                // Remove invoice document if either invoices are empty OR invoice_with_line_item is false
                await this._updateCheckoutPaymentAmount();

                const hasInvoices = value && value.length;
                const hasInvoiceWithLineItem = this.data.invoice_with_line_item;

                if (!hasInvoices || !hasInvoiceWithLineItem) {
                    this.data.credits = [];

                    const invoiceDocumentIndex = findIndex(
                        this.data.documents,
                        {
                            id: "4"
                        }
                    );

                    if (invoiceDocumentIndex !== -1) {
                        this.data.documents.splice(invoiceDocumentIndex, 1);
                    }
                } else {
                    const invoiceDocument = find(this.data.documents, {
                        id: "4"
                    });
                    const invoiceDocumentsList = find(this.data.documentsList, {
                        id: "4"
                    });

                    if (!invoiceDocument && !isEmpty(invoiceDocumentsList)) {
                        this.data.documents.push(invoiceDocumentsList);
                    }
                }
                this.emitSocketInvoiceChanged();
            }
        },
        "data.credits"() {
            this._updateCheckoutPaymentAmount();
        },
        "data.outstanding_amount"(value) {
            this.data.payment_amount = value;
            this._selectChange();
        },
        "data.payment_amount"(value) {
            this._selectChange();

            if (value <= 0) {
                this.data.payment_type = -1;
            }

            if (this.isPayingMore) {
                this.data.payment_type = -1;
            }

            if (value && this.isPaymentFund) {
                let selectedFund = this.getFundValue(this.data.payment_type);
                if (selectedFund && selectedFund.balance < value) {
                    this.data.payment_type = -1;
                }
            }
        },
        "data.payment_type"(value) {
            this._selectPaymentTypeObject();
            this._selectChange();
            if (this.is_cc_card_in) {
                this.waitForPaymentMethod = true;
            }

            if (this.isPaymentFund) {
                let self = this;
                let selectedFund = self.getFundValue(value);

                if (
                    selectedFund &&
                    selectedFund.balance < self.data.payment_amount
                ) {
                    self.data.payment_amount = selectedFund.balance;
                }
            }
        },
        "data.checkout_date"() {
            this.getEmailTemplate();
        },
        isPayingMore() {
            this.data.payment_type = -1;
        },
        "data.documents"(newValue) {
            this.data.export_type =
                newValue.length > 0 && this.data.client_email
                    ? EXPORT_EMAIL
                    : NO_EXPORT;
        }
    },
    created() {
        this.datePickerOptions.widgetParent = "#checkOutModal";
        this.timePickerOptions.widgetParent = "#checkOutModal";
        this.$root.$on(
            "stripe-reset-terminal-schedule",
            this.cancelStripeCollectionCheckout
        );
        this.$root.$on(
            "capturing-stripe-terminal-payment-schedule",
            this.capturingStripeTerminalCheckout
        );
        this.onListenToVBroadcast();
    },
    beforeDestroy() {
        this.data.invoices = [];
        this.emitSocketInvoiceChanged([]);
        this.offListenToVBroadcast();
    },
    mounted() {
        this.setSocketPaymentModalId(); // Id to be used for the socket invoice payment
        this.getFundList();
    },
    methods: {
        shown() {
            this._updateCheckoutPaymentAmount();
        },
        isPaymentModalShowing() {
            // This is used to check whether the checkout form is displayed when user is reload the page to emit the socket payment invoice to remove the warning message
            return this.currentPage == "checkout";
        },
        getParams() {
            let params = {};
            params.id = this.appData.id;
            params.client_id = this.appData.client_id;
            params.patient_id = this.appData.patient_id;
            params.staff_id = this.appData.staff_id;

            if (this.appData.provider) {
                params.provider_id = this.appData.provider.id;
            } else if (this.appData.default_provider) {
                params.provider_id = this.appData.default_provider.id;
            } else {
                params.provider_id = null;
            }

            params.invoices = _.map(this.data.invoices, invoice => invoice.id);
            params.credits = _.map(this.data.credits, credit => credit.id);
            params.documents = _.map(
                this.data.documents,
                document => document.id
            );

            params.swipe_unique = null;
            params.status_id = this.data.status;
            params.signature_cc = this.data.signature_cc;
            params.checkout_date = this.data.checkout_date;
            params.checkout_time = this.data.checkout_date;

            params.invoice_amount = this.data.invoice_amount;
            params.credit_amount = this.data.credit_amount;
            params.payment_amount = this.data.payment_amount;
            params.record_id = _.get(this, "data.rabies.record_id");
            params.tag = _.get(this, "data.rabies.tag");
            params.export_type = this.data.export_type;
            params.change = this.data.change;
            params.export_message = this.data.export_message;

            params.payment_method_id = this.data.payment_method_name
                ? this.data.payment_method_name.id
                : null;
            params.payment_method_name = this.data.payment_method_name
                ? this.data.payment_method_name.label
                : null;
            params.payment_type = this.data.payment_type;
            params.terminal = this.data.terminal;
            params.anet_transaction_id = this.data.anet_transaction_id;
            params.anet_transaction_output = this.data.anet_transaction_output;
            params.anet_transaction_name = this.data.anet_transaction_name;

            params.fund_id = this.getFundId();
            params.pay_from_fund = this.isPaymentFund ? 1 : 0;
            params.change_to_fund = this.isChangeFund ? 1 : 0;
            params.is_stripe_terminal = this.is_stripe_terminal;
            params.is_stripe_keyed_in = this.is_stripe_keyed_in;
            params.is_stripe_acss = this.is_stripe_acss;
            params.isSimulator = this.data.isSimulator;
            params.testCardNumber = this.data.testCardNumber;
            params.includeDeclined = this.data.includeDeclined;

            return params;
        },
        cancelStripeCollectionCheckout(terminal) {
            this.$root.$emit(
                "stripe-reset-terminal-schedule-checkout",
                terminal
            );
        },
        capturingStripeTerminalCheckout() {
            this.$root.$emit(
                "capturing-stripe-terminal-payment-schedule-checkout"
            );
        },
        getFundId() {
            if (this.isPaymentFund) {
                return this.data.payment_type;
            }
            if (this.isChangeFund) {
                return this.data.change.id;
            }

            return null;
        },
        getEmailTemplate: debounce(async function (event) {
            let params = [];
            params[0] = {
                business_id: this._setting.business.id,
                client_id: this.appData.client_id ? this.appData.client_id : "",
                recipient_type: 0,
                recipient_id: this.appData.client_id
                    ? this.appData.client_id
                    : "",
                email_type: CEMAIL.TYPE.CHECKOUT_DOCUMENT,
                appointment_id: this.appData.id,
                appointment_checked_out_date: this._toDateTime(
                    this.data.checkout_date
                ).toFormat(this._getLuxonFormat()),
                appointment_checked_out_time: this._toDateTime(
                    this.data.checkout_date
                ).toFormat("h:mm a"),
                patient_id: [this.appData.patient_id],
                checkout: true
            };

            let data = await $.post(
                process.env.APPS +
                    "index.php/common/appointment/getEmailTemplate",
                { params }
            );

            if (data && data.response) {
                this.data.export_message =
                    data.response[0].email_template.message;
            } else {
                this._message("Error retriving email message", "danger");
            }
        }, 500)
    }
};
</script>
